export const environment = {
  production: false,
  apiUrl: 'https://merchant-sandbox.scripay.com/',  // Note: removed trailing space
};